export const contactConfig = {
    phone: '03 89 42 87 34',
    phone2: '07 43 59 54 51',
    email: 'contact@akte-immobilier.com',
    address: '4 rue des Bonnes Gens 68100 Mulhouse',
    mapUrl: 'https://maps.google.com/?q=4+rue+des+Bonnes+Gens+68100+MULHOUSE',
    legalMentionsText: 'Mentions légales'
};
